<template>
  <section
    class="component-a17eeba3"
    resmed-component-name="custom_interactive_chart"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col-md-10 mb-5 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2 v-html="acf.headline"></h2>
            <p v-html="acf.introduction"></p>
          </div>
        </div>
        <div class="chart-wrapper">
          <div class="chart">
            <div class="bars" v-bind:class="{ 'is-active': active }">
              <div class="red"></div>
              <div class="blue"></div>
              <div class="purple"></div>
              <div class="purple-blue"></div>
            </div>
          </div>
          <div class="items text-center">
            <div class="item" v-for="item in acf.items">
              <figure>
                <img class="img-fluid" v-bind:src="`${item.icon}`" alt="" />
              </figure>
              <h5 v-bind:class="[item.color]">{{ item.title }}</h5>
              <p class="content" v-html="item.description"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import inView from "in-view"; // https://github.com/camwiegert/in-view

export default {
  name: "component-a17eeba3", // custom_interactive_chart
  props: ["acf"],
  data() {
    return {
      active: false,
    };
  },
  mounted() {
    inView.threshold(0.2);

    inView(".component-a17eeba3 .chart-wrapper")
      .on("enter", (el) => {
        this.active = true;
      })
      .on("exit", (el) => {
        this.active = false;
      });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-a17eeba3 {
  padding: 6rem 0 4rem 0;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: cover;

  @media (min-width: 992px) and (max-width: 1200px) {
    padding: 6rem 0 1rem 0;
  }
}

.component {
  h2 {
    position: relative;
    margin: 0 0 1rem 0;

    @extend %eyebrow-center;
  }

  h5 {
    margin-bottom: 0.25rem;
  }

  @media (max-width: 767px) {
    h5 {
      font-size: 12px;
    }

    .items {
      font-size: 12px;
    }
  }

  .chart-wrapper {
    @media (min-width: 992px) and (max-width: 1200px) {
      transform: scale(0.825);
    }
  }

  .chart {
    height: 180px;
    background-size: 940px;
    background-repeat: no-repeat;
    background-position: left bottom;

    @media (min-width: 768px) {
      height: 390px;
      background-image: url(data:image/svg+xml;base64,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);
    }

    @media (min-width: 992px) {
      background-position: 34% bottom;
    }

    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 0.5rem;

    .bars {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: baseline;
      width: 100%;
      padding: 0 0.75rem;

      @media (min-width: 576px) {
        padding: 0;
        width: 420px;
      }

      @media (min-width: 768px) {
        width: 490px;
      }

      @media (min-width: 768px) and (max-width: 992px) {
        transform: translateX(1.75rem);
      }

      @media (min-width: 992px) {
        width: 710px;
      }

      > div {
        width: 60px;
        height: 0;
        transition: all 1.5s ease-out;

        @media (min-width: 992px) {
          width: 80px;
        }
      }

      &.is-active {
        .red {
          background-color: #a7213b;
          height: calc(336px / 2);

          @media (min-width: 768px) {
            height: 336px;
          }
        }
        .blue {
          background-color: #167dbb;
          height: calc(296px / 2);

          @media (min-width: 768px) {
            height: 296px;
          }
        }
        .purple {
          background-color: #562a81;
          height: calc(244px / 2);

          @media (min-width: 768px) {
            height: 244px;
          }
        }
        .purple-blue {
          background-color: #394c9c;

          height: calc(216px / 2);

          @media (min-width: 768px) {
            height: 216px;
          }
        }
      }
    }
  }

  .items {
    display: flex;
    justify-content: center;
    // transform: scale(.825) translateX(0);

    @media (min-width: 768px) and (max-width: 992px) {
      transform: scale(0.825) translateX(2rem);
    }

    .item {
      // background: #CCC;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;

      padding: 1rem 0.325rem 0 0.325rem;
      width: 25%;

      > * {
        // width: 100%;
        // align-self: flex-start;
      }

      @media (max-width: 767px) {
        margin: 0 auto;
      }

      @media (min-width: 768px) {
        width: 210px;
      }

      @media (min-width: 992px) {
        padding: 2rem 2rem 0 2rem;
      }

      @media (min-width: 1200px) {
        width: 210px;
      }

      h5 + p {
        // position: absolute;
        // align-self: flex-end;
        // justify-self: flex-end;
      }

      figure {
        max-width: 3.5rem;
        margin: 0 auto 1rem auto;
        width: 100%;

        @media (min-width: 768px) {
          max-width: 5.5rem;
        }

        img {
          display: block;
        }
      }
    }
  }
}
</style>